// extracted by mini-css-extract-plugin
export default {"topNav":"P5-z","category":"Q5-z","noArrow":"R5-z","alternative":"S5-z","topLevelNavItem":"T5-z","navContainer":"U5-z","subcategoryHeading":"V5-z","subcategory":"W5-z"};